package blazern.lexisoup.domain.model

enum class Gender {
    MASCULINE,
    FEMININE,
    NEUTER,
}
